// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-8BK","question":"styles_question__3U7gV","description":"styles_description__2v3VC"};